import SlimSelect from 'slim-select';
import { parseOptions } from '../components/utils';

document.addEventListener('DOMContentLoaded', function () {
  initSlimSelects();
});

const whitespaceRegex = /^\s+/g;

type AjaxSettings = {
  url: string;
  delay?: number;
};

type SlimSettings = {
  placeholderText?: string;
  searchText?: string;
  searchingText?: string;
  searchPlaceholder?: string;
  hideSelected?: boolean;
  maxValuesShown?: number;
  tags?: boolean;
  ajax?: AjaxSettings;
  [key: string]: any;
};

const defaultSettings: Partial<SlimSettings> = {
  placeholderText: 'Seleziona',
  searchText: 'Nessun risultato trovato',
  searchingText: 'Ricerca in corso...',
  searchPlaceholder: 'Cerca...',
  addableText: 'Premi "Invio" per aggiungere&nbsp;<b>{value}</b>',
  maxValuesMessage: '{number} selezionati',
  hideSelected: false,
  maxValuesShown: 50
};

function _initSlimSelect(element: HTMLSelectElement | null): SlimSelect | undefined {
  if (!element) return undefined;

  // slim-select may attach an instance to the element; avoid TS error by using any
  const anyEl = element as any;
  if (anyEl.slim) {
    try {
      anyEl.slim.destroy();
    } catch {
      // ignore destroy errors
    }
  }

  // Read settings using shared parseOptions (supports relaxed "{ key: value }" format)
  const raw = element.getAttribute('data-slimselect') ?? null;
  const settings = parseOptions<Partial<SlimSettings>>(raw, {}) as SlimSettings;

  let events: Record<string, any> = {};

  if (settings.tags) {
    events.addable = function (value: string) {
      if (value.match(whitespaceRegex)) {
        return false;
      }

      return {
        text: value,
        value: value,
      };
    };
  }

  if (settings.ajax && settings.ajax.url) {
    let timeoutId: number | undefined;
    const delay = settings.ajax.delay ?? 300;
    events.search = function (search: string, currentData: any) {
      return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined') {
          if (timeoutId) {
            window.clearTimeout(timeoutId);
          }
          timeoutId = window.setTimeout(() => {
            if (!search || search.length < 2) {
              return reject('Inserisci almeno 2 caratteri');
            }

            const url = `${settings.ajax!.url}&query=${encodeURIComponent(search)}`;
            fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                return response.json();
              })
              .then((data) => {
                resolve(data);
              })
              .catch((err) => reject(err));
          }, delay);
        } else {
          // no window (SSR) -> reject
          reject('No window available');
        }
      });
    };
  }

  const mergedSettings = {
    ...defaultSettings,
    ...settings,
  };

  const ss = new SlimSelect({
    select: element,
    settings: mergedSettings,
    events: events,
  });

  return ss;
}

export function initSlimSelects(): void {
  const commonSelects = document.querySelectorAll<HTMLSelectElement>('[data-slimselect]');
  commonSelects.forEach((element) => {
    _initSlimSelect(element);
  });
}

export function initSlimSelect(elementSelector: string, selectedValue = ''): void {
  const element = document.querySelector<HTMLSelectElement>(elementSelector);
  const ss = _initSlimSelect(element);
  if (ss && selectedValue) {
    try {
      ss.setSelected(selectedValue);
    } catch {
      // ignore
    }
  }
}

